<form [formGroup]="addMediaForm" (ngSubmit)="addMedia()">
  <div class="row">
    <div class="form-group col-md-12">
      <label>Name <span class="text-danger small">(required)</span></label>
      <input type="text" class="form-control" [ngClass]="setClassInvalid(addMediaForm, 'name')" 
             formControlName="name" placeholder="Sky TG24" required>
    </div>
  </div>
  <div class="row">
    <div class="form-group col-md-4">
      <label>Email</label>
      <input type="email" class="form-control" [ngClass]="setClassInvalid(addMediaForm, 'email')"
             formControlName="email" placeholder="email@example.com">
    </div>
    <div class="form-group col-md-4">
      <label>Phone</label>
      <input type="text" class="form-control" [ngClass]="setClassInvalid(addMediaForm, 'phone')"
             formControlName="phone" placeholder="3331231231">
    </div>
    <div class="form-group col-md-4">
      <label>Live / Recorded</label>
      <select class="form-control" [ngClass]="setClassInvalid(addMediaForm, 'live')" formControlName="live">
        <option value="" selected>Select type</option>
        <option value="true">Live</option>
        <option value="false">Recorded</option>
      </select>
    </div>
  </div>
  <div formGroupName="socials" class="row">
    <div formGroupName="twitter" class="form-group col-md-3">
      <label>X</label>
      <input type="text" class="form-control" [ngClass]="setClassInvalid(addMediaForm, 'socials.twitter.username')"
             formControlName="username" (change)="formatUsername('twitter')" placeholder="mario_rossi">
    </div>
    <div formGroupName="instagram" class="form-group col-md-3">
      <label>Instagram</label>
      <input type="text" class="form-control" [ngClass]="setClassInvalid(addMediaForm, 'socials.instagram.username')"
             formControlName="username" (change)="formatUsername('instagram')" placeholder="mario.rossi">
    </div>
    <div formGroupName="facebook" class="form-group col-md-3">
      <label>Facebook</label>
      <input type="text" class="form-control" [ngClass]="setClassInvalid(addMediaForm, 'socials.facebook.username')"
             formControlName="username" (change)="formatUsername('facebook')" placeholder="MarioRossiOfficial">
    </div>
    <div formGroupName="linkedin" class="form-group col-md-3">
      <label>LinkedIn</label>
      <input type="text" class="form-control" [ngClass]="setClassInvalid(addMediaForm, 'socials.linkedin.username')"
             formControlName="username" (change)="formatUsername('linkedin')" placeholder="mario-rossi">
    </div>
  </div>
  <div class="row">
    <div class="form-group col-md-12">
      <label>Notes</label>
      <textarea class="form-control" rows="5" [ngClass]="setClassInvalid(addMediaForm, 'notes')"
                formControlName="notes" placeholder="Description, scheduling times, etc"></textarea>
    </div>
  </div>
  <div class="row">
    <div class="form-group col-md-12">
      <button class="btn btn-primary d-block" type="submit" [disabled]="!addMediaForm.valid">
        <i class="fa fa-plus-circle"></i> Add media
      </button>
    </div>
  </div>
</form>